export default __webpack_public_path__ + "static/media/thin.59dcda04.svg";